'use client';
import React, { useState } from 'react';

// Importing the card components (Visa, MasterCard, etc.)
import VisaCard from '../../assets/profileModal/visaCardComponentSVG';
import MasterCard from '../../assets/profileModal/masterCardComponentSVG';
import AmexCard from '../../assets/profileModal/amexCardComponent';
import DinersCard from '../../assets/profileModal/dinersCardComponent';
import DiscoverCard from '../../assets/profileModal/discoverCardComponent';
import JCBCard from '../../assets/profileModal/jcbCardComponent';
import UnionPayCard from '../../assets/profileModal/unionpayCardComponent';
import BlankCard from '../../assets/profileModal/blankCardComponent';

export default function BillingSection() {
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('card');
    const [formData, setFormData] = useState({
        cardNumber: '',
        expDate: '',
        cvc: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handlePaymentMethodChange = (e) => {
        setSelectedPaymentMethod(e.target.value);
    };

    return (
        <>
            <div className="bg-white border rounded-lg shadow-sm">

                {/* Payment Method Options */}
                <div className="space-y-2 sm:space-y-4 mt-4">
                    <div className="flex items-center px-6">
                        <input
                            type="radio"
                            id="card"
                            name="paymentMethod"
                            value="card"
                            checked={selectedPaymentMethod === 'card'}
                            onChange={handlePaymentMethodChange}
                            className="mr-2"
                        />
                        <label htmlFor="card" className="text-sm sm:text-lg">Card</label>
                        {/* Card Icons Next to Card Radio Button */}
                        <div className="flex space-x-1 ml-auto">
                            <VisaCard className="w-4 h-4 lg:w-8 lg:h-8" />
                            <MasterCard className="w-4 h-4 lg:w-8 lg:h-8" />
                            <AmexCard className="w-4 h-4 lg:w-8 lg:h-8" />
                            <DinersCard className="w-4 h-4 lg:w-8 lg:h-8" />
                            <DiscoverCard className="w-4 h-4 lg:w-8 lg:h-8" />
                            <JCBCard className="w-4 h-4 lg:w-8 lg:h-8" />
                            <UnionPayCard className="w-4 h-4 lg:w-8 lg:h-8" />
                        </div>
                    </div>

                    {/* Card Details */}

                    <div className="mt-4 space-y-2 sm:space-y-4 border-y p-6 bg-[#fcfcfd] w-full">
                        <div className="relative">
                            <input
                                type="text"
                                id="cardNumber"
                                name="cardNumber"
                                value={formData.cardNumber}
                                onChange={handleInputChange}
                                className="mt-1 block w-full p-2 sm:p-4 border border-gray-300 rounded-full shadow-sm text-sm lg:text-lg"
                                placeholder="Card Number"
                                required
                            />
                            {/* MasterCard Icon centered inside Card Number Field with a slight space from right  */}
                            <div className="absolute right-4 top-1/4 transform translate-b-1/2 translate-t-1/2">
                                <MasterCard className="w-4 h-4 lg:w-8 lg:h-8" stroke="#ffffff" />
                            </div>
                        </div>



                        <div className="flex space-x-4">
                            <div className="w-1/2">
                                <input
                                    type="text"
                                    id="expDate"
                                    name="expDate"
                                    value={formData.expDate}
                                    onChange={handleInputChange}
                                    className="mt-1 block w-full p-2 sm:p-4 border border-gray-300 rounded-full shadow-sm text-base lg:text-lg"
                                    placeholder="Exp. Date"
                                    required
                                />
                            </div>

                            <div className="w-1/2 relative">
                                <input
                                    type="text"
                                    id="cvc"
                                    name="cvc"
                                    value={formData.cvc}
                                    onChange={handleInputChange}
                                    className="mt-1 block w-full p-2 sm:p-4 border border-gray-300 rounded-full shadow-sm text-sm sm:text-lg"
                                    placeholder="CVC"
                                    required
                                />
                                {/* Blank Card Icon inside CVC Field */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2">
                                    <BlankCard className="w-4 h-4 lg:w-8 lg:h-8" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="px-6 py-2">
                        <input
                            type="radio"
                            id="paypal"
                            name="paymentMethod"
                            value="paypal"
                            checked={selectedPaymentMethod === 'paypal'}
                            onChange={handlePaymentMethodChange}
                            className="mr-2"
                        />
                        <label htmlFor="paypal" className="text-sm sm:text-lg">PayPal</label>
                    </div>

                    <div className="flex items-center justify-between p-6 border-t">
                        <div className="inline-flex items-center">
                            <input
                                type="radio"
                                id="payPalCard"
                                name="paymentMethod"
                                value="payPalCard"
                                checked={selectedPaymentMethod === 'payPalCard'}
                                onChange={handlePaymentMethodChange}
                                className="mr-2"
                            />
                            <label htmlFor="payPalCard" className="text-sm sm:text-lg">Pay by Card via PayPal</label>
                        </div>

                        {/* Card Icons Visible When PayPal Card Option is Selected */}
                        <div className="flex space-x-2 ml-auto">
                            <VisaCard className="w-4 h-4 lg:w-8 lg:h-8" />
                            <MasterCard className="w-4 h-4 lg:w-8 lg:h-8" />
                            <AmexCard className="w-4 h-4 lg:w-8 lg:h-8" />
                        </div>
                    </div>

                </div>

            </div>
            {/* Save Changes Button */}
            <div className="bottom-0 mt-6 text-center w-full">
                <button
                    onClick={(e) => {
                        e.preventDefault();
                        console.log('Payment Details:', formData);
                    }}
                    className="py-[8px] sm:py-[15px] px-2 sm:px-6 bg-[#0062ff] text-white rounded-full hover:bg-opacity-90  w-full text-sm sm:text-lg"
                >
                    Save Changes
                </button>
            </div>
        </>
    );
}
